module.exports = __webpack_public_path__ + "media/images/goods_btn_l-ae80665b41024a91e962fa1825655f5e.gif";